export default __webpack_public_path__ + "static/media/medium.86964042.svg";